// extracted by mini-css-extract-plugin
export default {"searchFacetsContainer":"searchFacetsContainer__YjcxY","active":"active__YzI0Y"};